import CustomerServiceSupervisorRequests from "@/views/customerServiceSupervisor/Requests/AllRequests/CustomerServiceSupervisorRequests.vue";
import GraphsContentForCustomerService from "@/views/admin/Charts/GraphsContentForCustomerService.vue";
import ProductivityContentForCustomerService from "@/views/admin/Charts/ProductivityContentForCustomerService";
import AgentSupport from "@/views/agent2/AgentSupport.vue";
import SupportContentNewDesign from "@/views/agent2/SupportContentNewDesign.vue";

const SUPERVISOR_BASE_PATH = "/customer-service-supervisor";

export const customerServiceSupervisorRoutes = [
  {
    path: SUPERVISOR_BASE_PATH,
    name: "customerServiceSupervisorHome",
    redirect: `${SUPERVISOR_BASE_PATH}/requests-customer-service`,
    meta: {
      listed: false,
      page_name: "مشرف خدمة العملاء",
    },
  },
  {
    path: `${SUPERVISOR_BASE_PATH}/requests-customer-service`,
    name: "customerServiceSupervisorRequests",
    component: CustomerServiceSupervisorRequests,
    meta: {
      listed: true,
      group: "خدمة العملاء",
      page_name: "سلة خدمة العملاء",
    },
  },
  {
    path: `${SUPERVISOR_BASE_PATH}/charts/dailyPerformanceForCustomerService`,
    name: "customerServiceSupervisorDailyReportForCustomerService",
    component: GraphsContentForCustomerService,
    meta: {
      listed: true,
      group: "خدمة العملاء",
      page_name: "الأداء اليومي لخدمه العملاء",
    },
  },
  {
    path: `${SUPERVISOR_BASE_PATH}/charts/productivityForCustomerService`,
    name: "customerServiceSupervisorProductivityForCustomerService",
    component: ProductivityContentForCustomerService,
    meta: {
      listed: true,
      group: "خدمة العملاء",
      page_name: "تقرير الإنتاجية لخدمة العملاء",
    },
  },
  {
    path: `${SUPERVISOR_BASE_PATH}/support`,
    name: "customerServiceSupervisorSupport",
    component: AgentSupport,
    meta: {
      listed: true,
      group: "طلبات الدعم الفني",
      page_name: "طلبات الدعم الفني",
    },
  },
  {
    path: `${SUPERVISOR_BASE_PATH}/support-tickets/:id`,
    name: "customerServiceSupervisorSupportContent",
    component: SupportContentNewDesign,
    meta: {
      listed: false,
      page_name: "محتوى التذكرة",
    },
  },
];
